export default "__VITE_ASSET__BkTer1yr__"